import { ref, reactive } from 'vue';

const DEFAULT_MODEL = {
	name: null,
	email: null,
	phonenumber: null,
	accountNumber: null,
	sum: null,
	date: null,
	invoiceId: null,
	merchant: null,
	type: null,
	description: null,
	privacyPolicy: null,
	statement: null,
	captchaKey: null,
	captchaText: null
};

const files = ref([]);
const uploadedFiles = ref([]);
const model = reactive(structuredClone(DEFAULT_MODEL));

const resetModel = () => {
	files.value = [];
	uploadedFiles.value = [];
	Object.assign(model, DEFAULT_MODEL);
};

export const useStore = () => {
	return { files, uploadedFiles, model, resetModel };
};
